export let SocialButton = ({network}) => {
    return <a className={`btn btn-outline-secondary btn-icon btn-sm btn-${network} rounded-circle mt-3 ms-3`}
              href="/#" onClick={e => e.preventDefault()}>
        <i className={`ai-${network}`}/>
    </a>
}

export let SmallSocialButton = ({network}) => {
    return <a className="nav-link p-2 me-2" href="/#"
              aria-label="Facebook" data-bs-original-title="Facebook" onClick={e => e.preventDefault()}>
        <i className={`ai-${network}`}/>
    </a>
}